export const environment = {
  production: true
};



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/odQvAFzU/0/heba/118365/src/main/frontend/src/environments/environment.ts